import { DeterminateLoader } from '@modules/common/components/DeterminateLoader';
import { CheckCircleOutline, CloseRounded } from '@mui/icons-material';
import { Stack, alpha } from '@mui/material';
import { useCallback, useState } from 'react';

interface WisdomConversationStepIndicatorProps {
  isResponseArrived: boolean;
  isDisabled: boolean;
  isResponseHalted: boolean;
}

export const WisdomConversationStepIndicator = ({
  isResponseArrived,
  isDisabled,
  isResponseHalted,
}: WisdomConversationStepIndicatorProps) => {
  const [isProgressCompleted, setIsProgressCompleted] = useState(false);

  const isLoading = !isResponseArrived && !isResponseHalted && !isDisabled;

  const onCompleteProgress = useCallback(() => {
    setIsProgressCompleted(true);
  }, []);

  const renderIndicatorIcon = () => {
    if (!isProgressCompleted) {
      return (
        <DeterminateLoader
          duration={40 * 1000} // 40 seconds
          updateInterval={1000}
          maxProgress={80}
          isCompleted={!isLoading}
          onComplete={onCompleteProgress}
          circularProgressProps={{
            size: 20,
          }}
        />
      );
    }

    if (isResponseArrived) {
      return (
        <CheckCircleOutline
          fontSize="medium"
          sx={{
            color: 'success.light',
          }}
        />
      );
    }

    if (isDisabled) {
      return null;
    }

    if (isResponseHalted) {
      return (
        <CloseRounded
          fontSize="medium"
          sx={{
            color: (theme) => alpha(theme.palette.warning.main, 0.5),
          }}
        />
      );
    }

    return null;
  };

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      width="40px"
      height="30px"
    >
      {renderIndicatorIcon()}
    </Stack>
  );
};
